const extendShareTimeline = require('./timeline')

const extendApp = () => {
    extendShareTimeline()

    if (global && global.Page && global.Component) {
        global.Page = Page
        global.Component = Component
    }
}
module.exports = extendApp
